import { useEffect, useRef, useState } from "react";
import styles from "./AutoComplete.module.scss";

const AutoComplete = ({ suggestions, onChange, name, value }) => {
  const [_userInput, _setUserInput] = useState(value);
  const [_highlightedSuggestion, _setHighlightedSuggestion] = useState("");
  const _inputRef = useRef(null);

  useEffect(() => {
    _setUserInput(value);
  }, [value]);

  const _trimInput = (input) => {
    if (input.charAt(input.length - 1) === ",") {
      return `${input.slice(0, -1).trim()},`;
    }

    return input;
  };

  const _allowInputChange = (input) => {
    if (input.charAt(input.length - 1) === " ") {
      if (input.length < 2) {
        return false;
      }

      if (input.charAt(input.length - 2) === ",") {
        return false;
      }
    }

    return true;
  };

  const _getInputSegments = (input) => {
    const _allSegments = input.split(",");
    const _lastSegment = _allSegments.pop().trim();

    return { baseSegments: _allSegments, lastSegment: _lastSegment };
  };

  const _getInputSuggestions = (suggestions, baseSegments, lastSegment) => {
    return suggestions.filter(
      (suggestion) =>
        suggestion.toLowerCase().startsWith(lastSegment.toLowerCase()) &&
        !baseSegments.includes(suggestion)
    );
  };

  const _handleInputChange = (e) => {
    const _userInput = _trimInput(e.target.value);

    if (!_allowInputChange(_userInput)) {
      return;
    }

    const { baseSegments, lastSegment } = _getInputSegments(_userInput);
    const _inputSuggestions = _getInputSuggestions(suggestions, baseSegments, lastSegment);

    _setUserInput(_userInput);
    _setHighlightedSuggestion(_inputSuggestions.length > 0 ? _inputSuggestions[0] : "");

    onChange({ target: { name, value: _userInput } });
  };

  const _handleKeyDown = (e) => {

    if (e.key === "Tab" && _highlightedSuggestion) {
      e.preventDefault();

      const { baseSegments: _baseSegments } = _getInputSegments(_userInput);

      const _updatedInput = `${_baseSegments.join(",")}${_baseSegments.length > 0 ? "," : ""}${_highlightedSuggestion}`;

      _setUserInput(_updatedInput);
      _setHighlightedSuggestion("");

      onChange({ target: { name, value: _updatedInput } });
    }
  };

  const _cutString = (input, suggestion) => {
    const { baseSegments: _baseSegments } = _getInputSegments(input);

    const _suggestionExtension = `${_baseSegments.join(",")}${_baseSegments.length > 0 ? "," : ""}${suggestion}`;

    const _segments = _suggestionExtension.split(input);
    const _prefix = input;
    const _suffix = _segments[1] ?? "";

    return { prefix: _prefix, suffix: _suffix };
  };

  const { prefix: _prefix, suffix: _suffix } = _cutString(_userInput, _highlightedSuggestion);

  return (
    <div className={styles["autocomplete"]}>
      <input
        type="text"
        ref={_inputRef}
        value={_userInput}
        onChange={_handleInputChange}
        onKeyDown={_handleKeyDown}
        className={styles["autocomplete__user"]}
        autoComplete="off"
      />
      {_highlightedSuggestion && _userInput && (
        <div className={styles["autocomplete__suggestion"]}>
          <span className={styles["color--user"]}>{_prefix}</span>
          <span className={styles["color--suggestion"]}>{_suffix}</span>
        </div>
      )}
    </div>
  );
};

export default AutoComplete;
